import React from 'react';
import Header from './Header';

const Layout = (props) => (
    <div className="container">
        
        <Header />

        <main className="page-content">
          <div className="section-title">
            <h2>Calculate your <br />uplift with Publift</h2>
          </div>
          
          {props.children}
          
        </main>

        <footer className="pb-3 pt-md-4">
          <p><strong>Disclaimer:</strong></p>
          <ul>
            <li>Estimates are based on previous revenue performance from existing Publift clients and implementing header bidding along with key optimisations such as improving the ad layout.</li>
            <li>Estimations are subject to your website and existing setup</li>
          </ul>
        </footer>
      </div>
)

export default Layout;